import { useQuery } from '@tanstack/react-query'
import { useFormikContext } from 'formik'
import { useParams } from 'react-router-dom'
import requests from 'service/api'

export function isZaraHomeBrand(brand) {
  return String(brand || '').includes('ZaraHome')
}

export function useSelectedSizeGroup() {
  const { values } = useFormikContext()
  const { brand } = useParams()
  const isHome = isZaraHomeBrand(brand)
  const id = values?.sizeGroup

  return useQuery({
    queryKey: ['orderSizeGroup', isHome ? 'home' : 'zara', id],
    queryFn: async () => {
      const request = isHome ? requests.size.getGroupHome : requests.size.getGroup
      const { data } = await request(id)
      return data || null
    },
    enabled: !!id,
    placeholderData: null,
  })
}
